export const EIN_ANSWER = {
  WILL_BUY_EIN: 'willBuyEIN',
  WAITING_EIN: 'waitingEIN',
  HAVE_EIN: 'haveEIN'
};
